// import setCookie from '../../session/setCookie'
import VitOAuth from 'vit-oauth'

export default function cendynLoginRedirect(currentQuery) {
  // setCookie('flowCurrentQuery', currentQuery.query.toString(), 1)
  window.localStorage.setItem('flowCurrentQuery', currentQuery.query.toString())

  const config = {
    clientId: process.env.REACT_APP_CRM_API_APP_ID,
    redirectUri: process.env.REACT_APP_CRM_AUTH_REDIRECT_URL,
    authorizationEndpoint: process.env.REACT_APP_CRM_AUTH_PROVIDER_URL,
    tokenEndpoint: process.env.REACT_APP_CRM_PROVIDER_URL,
    requestedScopes: 'crm_user',
    supportsRefresh: false,
    crypto: window.crypto
  }
  const OAuthClient = new VitOAuth(config)
  const redirectEvent = async () => {
    const url = await OAuthClient.generateLoginUrl()
    window.location.href = url
  }

  return redirectEvent()
}


// WEBPACK FOOTER //
// ./src/utilities/profile/cendyn/cendynLoginRedirect.js